// Interface copy only. Article and project data must never pass through this catalog.
export const messages = {
  "Every project starts with a conversation.": {"en": "Every project starts with a conversation.", "fr": "Tout commence par un échange."},
  "Tell me what you have in mind, where you are now, and what you would like to build.": {"en": "Tell me what you have in mind, where you are now, and what you would like to build.", "fr": "Parlez-moi de votre idée, de vos besoins et de ce que vous aimeriez construire."},
  "Write me an email": {"en": "Write me an email", "fr": "M’écrire un email"},
  "Opens your email app": {"en": "Opens your email app", "fr": "Ouvre votre messagerie"},
  "Available for new projects": {"en": "Available for new projects", "fr": "Disponible pour vos projets"},
  "A direct conversation": {"en": "A direct conversation", "fr": "Un échange en direct"},
  "You will hear directly from me, usually within 24–48 hours.": {"en": "You will hear directly from me, usually within 24–48 hours.", "fr": "Je vous réponds personnellement, généralement sous 24 à 48 heures."},
  "Elsewhere online": {"en": "Elsewhere online", "fr": "Retrouvons-nous aussi sur"},
  "Read": { en: "Read", fr: "Lire" },
  "Go to image": { en: "Go to image", fr: "Afficher l’image" },
  "Home": {
    "en": "Home",
    "fr": "Accueil"
  },
  "About": {
    "en": "About",
    "fr": "À propos"
  },
  "Work": {
    "en": "Work",
    "fr": "Projets"
  },
  "Get in Touch": {
    "en": "Get in Touch",
    "fr": "Me contacter"
  },
  "Latest Articles": {
    "en": "Latest Articles",
    "fr": "Derniers articles"
  },
  "Practical notes on AI, engineering, and the tools I use to build reliable digital products.": {
    "en": "Practical notes on AI, engineering, and the tools I use to build reliable digital products.",
    "fr": "Notes pratiques sur l’IA, le développement et les outils que j’utilise pour créer des produits numériques fiables."
  },
  "View all articles": {
    "en": "View all articles",
    "fr": "Voir tous les articles"
  },
  "min read": {
    "en": "min read",
    "fr": "min de lecture"
  },
  "I'm a": {
    "en": "I'm a",
    "fr": "Je suis"
  },
  "web developer": {
    "en": "web developer",
    "fr": "développeur web"
  },
  "and": {
    "en": "and",
    "fr": "et"
  },
  "AI specialist": {
    "en": "AI specialist",
    "fr": "spécialiste en IA"
  },
  "based in Angers, France. I create innovative digital solutions and leverage cutting-edge technology to solve complex problems for businesses.": {
    "en": "based in Angers, France. I create innovative digital solutions and leverage cutting-edge technology to solve complex problems for businesses.",
    "fr": "basé à Angers, en France. Je crée des solutions numériques innovantes et utilise les technologies de pointe pour résoudre les problèmes complexes des entreprises."
  },
  "Web Development": {
    "en": "Web Development",
    "fr": "Développement web"
  },
  "Modern, responsive web applications tailored to your needs.": {
    "en": "Modern, responsive web applications tailored to your needs.",
    "fr": "Des applications web modernes et adaptatives, conçues pour vos besoins."
  },
  "AI Integration": {
    "en": "AI Integration",
    "fr": "Intégration de l’IA"
  },
  "Leveraging artificial intelligence to enhance products and workflows.": {
    "en": "Leveraging artificial intelligence to enhance products and workflows.",
    "fr": "L’intelligence artificielle au service de vos produits et de vos processus."
  },
  "IT Consulting": {
    "en": "IT Consulting",
    "fr": "Conseil informatique"
  },
  "Strategic guidance on technology decisions for your business.": {
    "en": "Strategic guidance on technology decisions for your business.",
    "fr": "Un accompagnement stratégique dans les choix technologiques de votre entreprise."
  },
  "What I Do": {
    "en": "What I Do",
    "fr": "Mon expertise"
  },
  "Developer": {
    "en": "Developer",
    "fr": "Développeur"
  },
  "Project Manager": {
    "en": "Project Manager",
    "fr": "Chef de projet"
  },
  "10+ years of experience": {
    "en": "10+ years of experience",
    "fr": "Plus de 10 ans d’expérience"
  },
  "Full-stack developer": {
    "en": "Full-stack developer",
    "fr": "Développeur full-stack"
  },
  "AI & ML specialist": {
    "en": "AI & ML specialist",
    "fr": "Spécialiste en IA et apprentissage automatique"
  },
  "Based in Angers, France": {
    "en": "Based in Angers, France",
    "fr": "Basé à Angers, France"
  },
  "Let's work together": {
    "en": "Let's work together",
    "fr": "Travaillons ensemble"
  },
  "Have a project in mind? I'd love to hear about it. Let's discuss how I can help bring your ideas to life.": {
    "en": "Have a project in mind? I'd love to hear about it. Let's discuss how I can help bring your ideas to life.",
    "fr": "Un projet en tête ? Parlons-en. Voyons ensemble comment je peux vous aider à concrétiser vos idées."
  },
  "Send me a message →": {
    "en": "Send me a message →",
    "fr": "Envoyez-moi un message →"
  },
  "Founder": {
    "en": "Founder",
    "fr": "Fondateur"
  },
  "IT Department Manager": {
    "en": "IT Department Manager",
    "fr": "Responsable informatique"
  },
  "Research Engineer": {
    "en": "Research Engineer",
    "fr": "Ingénieur de recherche"
  },
  "Web & Mobile Developer": {
    "en": "Web & Mobile Developer",
    "fr": "Développeur web et mobile"
  },
  "Programmer Analyst": {
    "en": "Programmer Analyst",
    "fr": "Analyste programmeur"
  },
  "Experience": {
    "en": "Experience",
    "fr": "Expérience"
  },
  "Selected Work": {
    "en": "Selected Work",
    "fr": "Sélection de projets"
  },
  "View Project": {
    "en": "View Project",
    "fr": "Voir le projet"
  },
  "View all projects": {
    "en": "View all projects",
    "fr": "Voir tous les projets"
  },
  "Virtuoz Solutions Logo": {
    "en": "Virtuoz Solutions Logo",
    "fr": "Logo Virtuoz Solutions"
  },
  "Scroll to top": {
    "en": "Scroll to top",
    "fr": "Retour en haut"
  },
  "Close menu": {
    "en": "Close menu",
    "fr": "Fermer le menu"
  },
  "Open menu": {
    "en": "Open menu",
    "fr": "Ouvrir le menu"
  },
  "Toggle menu": {
    "en": "Toggle menu",
    "fr": "Ouvrir ou fermer le menu"
  },
  "Innovative web development and AI solutions with over a decade of experience across various industries.": {
    "en": "Innovative web development and AI solutions with over a decade of experience across various industries.",
    "fr": "Des solutions innovantes en développement web et en IA, avec plus de dix ans d’expérience dans différents secteurs."
  },
  "Process Automation": {
    "en": "Process Automation",
    "fr": "Automatisation des processus"
  },
  "Have a project in mind? Let's talk about it!": {
    "en": "Have a project in mind? Let's talk about it!",
    "fr": "Un projet en tête ? Parlons-en !"
  },
  "Virtuoz Solutions. All rights reserved.": {
    "en": "Virtuoz Solutions. All rights reserved.",
    "fr": "Virtuoz Solutions. Tous droits réservés."
  },
  "Privacy Policy": {
    "en": "Privacy Policy",
    "fr": "Politique de confidentialité"
  },
  "Terms of Service": {
    "en": "Terms of Service",
    "fr": "Conditions d’utilisation"
  },
  "Failed to load project details": {
    "en": "Failed to load project details",
    "fr": "Impossible de charger les détails du projet"
  },
  "Project not found.": {
    "en": "Project not found.",
    "fr": "Projet introuvable."
  },
  "Previous image": {
    "en": "Previous image",
    "fr": "Image précédente"
  },
  "Next image": {
    "en": "Next image",
    "fr": "Image suivante"
  },
  "Visit Project": {
    "en": "Visit Project",
    "fr": "Visiter le projet"
  },
  "View Code": {
    "en": "View Code",
    "fr": "Voir le code"
  },
  "Loading...": {
    "en": "Loading...",
    "fr": "Chargement…"
  },
  "Toggle theme": {
    "en": "Toggle theme",
    "fr": "Changer de thème"
  },
  "Light": {
    "en": "Light",
    "fr": "Clair"
  },
  "Dark": {
    "en": "Dark",
    "fr": "Sombre"
  },
  "Unable to load project": {
    "en": "Unable to load project",
    "fr": "Impossible de charger le projet"
  },
  "Project not found": {
    "en": "Project not found",
    "fr": "Projet introuvable"
  },
  "Return to Portfolio": {
    "en": "Return to Portfolio",
    "fr": "Retour au portfolio"
  },
  "Back to all projects": {
    "en": "Back to all projects",
    "fr": "Retour aux projets"
  },
  "Gallery": {
    "en": "Gallery",
    "fr": "Galerie"
  },
  "Project Links": {
    "en": "Project Links",
    "fr": "Liens du projet"
  },
  "No public links are available for this project.": {
    "en": "No public links are available for this project.",
    "fr": "Aucun lien public n’est disponible pour ce projet."
  },
  "Related Projects": {
    "en": "Related Projects",
    "fr": "Projets similaires"
  },
  "Thoughts, insights, and discoveries from my exploration of technology and development.": {
    "en": "Thoughts, insights, and discoveries from my exploration of technology and development.",
    "fr": "Réflexions, analyses et découvertes au fil de mon exploration des technologies et du développement."
  },
  "Search articles...": {
    "en": "Search articles...",
    "fr": "Rechercher des articles…"
  },
  "All": {
    "en": "All",
    "fr": "Tous"
  },
  "No articles found": {
    "en": "No articles found",
    "fr": "Aucun article trouvé"
  },
  "Try adjusting your search or filter to find what you're looking for.": {
    "en": "Try adjusting your search or filter to find what you're looking for.",
    "fr": "Modifiez votre recherche ou vos filtres pour trouver ce que vous cherchez."
  },
  "Clear Filters": {
    "en": "Clear Filters",
    "fr": "Réinitialiser les filtres"
  },
  "Page Not Found": {
    "en": "Page Not Found",
    "fr": "Page introuvable"
  },
  "The page you are looking for doesn't exist or has been moved.": {
    "en": "The page you are looking for doesn't exist or has been moved.",
    "fr": "La page que vous recherchez n’existe pas ou a été déplacée."
  },
  "Go Home": {
    "en": "Go Home",
    "fr": "Retour à l’accueil"
  },
  "Go Back": {
    "en": "Go Back",
    "fr": "Retour"
  },
  "Explore a selection of my personal projects and experiments in web development, AI, and more.": {
    "en": "Explore a selection of my personal projects and experiments in web development, AI, and more.",
    "fr": "Découvrez une sélection de mes projets personnels et expérimentations en développement web, en IA et bien plus encore."
  },
  "No projects found in this category.": {
    "en": "No projects found in this category.",
    "fr": "Aucun projet trouvé dans cette catégorie."
  },
  "AI Technologies": {
    "en": "AI Technologies",
    "fr": "Technologies d’IA"
  },
  "Project Management": {
    "en": "Project Management",
    "fr": "Gestion de projet"
  },
  "Building modern, responsive, and scalable web applications using the latest technologies.": {
    "en": "Building modern, responsive, and scalable web applications using the latest technologies.",
    "fr": "Création d’applications web modernes, adaptatives et évolutives avec les dernières technologies."
  },
  "Implementing artificial intelligence solutions to enhance your applications.": {
    "en": "Implementing artificial intelligence solutions to enhance your applications.",
    "fr": "Mise en œuvre de solutions d’intelligence artificielle pour enrichir vos applications."
  },
  "Computer Vision": {
    "en": "Computer Vision",
    "fr": "Vision par ordinateur"
  },
  "NLP": {
    "en": "NLP",
    "fr": "Traitement du langage naturel"
  },
  "Streamlining workflows and automating repetitive tasks to improve efficiency.": {
    "en": "Streamlining workflows and automating repetitive tasks to improve efficiency.",
    "fr": "Optimisation des processus et automatisation des tâches répétitives pour gagner en efficacité."
  },
  "Workflow Automation": {
    "en": "Workflow Automation",
    "fr": "Automatisation des flux de travail"
  },
  "API Integration": {
    "en": "API Integration",
    "fr": "Intégration d’API"
  },
  "CI/CD Pipelines": {
    "en": "CI/CD Pipelines",
    "fr": "Pipelines CI/CD"
  },
  "Expert advice on technology decisions, architecture, and digital strategy.": {
    "en": "Expert advice on technology decisions, architecture, and digital strategy.",
    "fr": "Des conseils experts sur les choix technologiques, l’architecture et la stratégie numérique."
  },
  "Technology Strategy": {
    "en": "Technology Strategy",
    "fr": "Stratégie technologique"
  },
  "System Architecture": {
    "en": "System Architecture",
    "fr": "Architecture des systèmes"
  },
  "Digital Transformation": {
    "en": "Digital Transformation",
    "fr": "Transformation numérique"
  },
  "Independent - Founder of Virtuoz Solutions": {
    "en": "Independent - Founder of Virtuoz Solutions",
    "fr": "Indépendant — Fondateur de Virtuoz Solutions"
  },
  "Feb 2020 - Present": {
    "en": "Feb 2020 - Present",
    "fr": "Fév. 2020 - Aujourd’hui"
  },
  "Development of web and mobile solutions": {
    "en": "Development of web and mobile solutions",
    "fr": "Développement de solutions web et mobiles"
  },
  "Oct 2020 - Present": {
    "en": "Oct 2020 - Present",
    "fr": "Oct. 2020 - Aujourd’hui"
  },
  "Oct 2019 - Oct 2020": {
    "en": "Oct 2019 - Oct 2020",
    "fr": "Oct. 2019 - Oct. 2020"
  },
  "Sep 2017 - Oct 2019": {
    "en": "Sep 2017 - Oct 2019",
    "fr": "Sept. 2017 - Oct. 2019"
  },
  "Sep 2015 - Sep 2017": {
    "en": "Sep 2015 - Sep 2017",
    "fr": "Sept. 2015 - Sept. 2017"
  },
  "Sep 2014 - Aug 2015": {
    "en": "Sep 2014 - Aug 2015",
    "fr": "Sept. 2014 - Août 2015"
  },
  "Rapido, ERP development in .Net (C#)": {
    "en": "Rapido, ERP development in .Net (C#)",
    "fr": "Rapido, développement ERP en .Net (C#)"
  },
  "About Me": {
    "en": "About Me",
    "fr": "À propos de moi"
  },
  "With over a decade of experience in development and IT, I'm passionate about creating": {
    "en": "With over a decade of experience in development and IT, I'm passionate about creating",
    "fr": "Avec plus de dix ans d’expérience en développement et en informatique, je suis passionné par la création de"
  },
  "innovative solutions": {
    "en": "innovative solutions",
    "fr": "solutions innovantes"
  },
  "that leverage the latest technologies.": {
    "en": "that leverage the latest technologies.",
    "fr": "qui s’appuient sur les dernières technologies."
  },
  "Project Manager & Developer": {
    "en": "Project Manager & Developer",
    "fr": "Chef de projet et développeur"
  },
  "I'm a passionate project manager and developer specializing in": {
    "en": "I'm a passionate project manager and developer specializing in",
    "fr": "Chef de projet et développeur passionné, je suis spécialisé en"
  },
  "C#, React JS, React Native, and Flutter": {
    "en": "C#, React JS, React Native, and Flutter",
    "fr": "C#, React JS, React Native et Flutter"
  },
  ". With extensive experience leading development teams, I excel at creating innovative solutions across various industries.": {
    "en": ". With extensive experience leading development teams, I excel at creating innovative solutions across various industries.",
    "fr": ". Fort d’une solide expérience dans la direction d’équipes de développement, je crée des solutions innovantes pour différents secteurs."
  },
  "I leverage": {
    "en": "I leverage",
    "fr": "J’utilise"
  },
  "Azure, GitHub, and GitLab": {
    "en": "Azure, GitHub, and GitLab",
    "fr": "Azure, GitHub et GitLab"
  },
  "in my workflow, with a particular focus on process automation to streamline development and operations.": {
    "en": "in my workflow, with a particular focus on process automation to streamline development and operations.",
    "fr": "au quotidien, en mettant l’accent sur l’automatisation des processus pour simplifier le développement et les opérations."
  },
  "I closely follow developments in AI models including": {
    "en": "I closely follow developments in AI models including",
    "fr": "Je suis de près l’évolution des modèles d’IA, notamment"
  },
  "LLAMA, GPT, Claude, Gemini, and Deepseek": {
    "en": "LLAMA, GPT, Claude, Gemini, and Deepseek",
    "fr": "LLAMA, GPT, Claude, Gemini et Deepseek"
  },
  ", integrating the latest AI capabilities into my projects.": {
    "en": ", integrating the latest AI capabilities into my projects.",
    "fr": ", et j’intègre leurs dernières capacités à mes projets."
  },
  "My Skills": {
    "en": "My Skills",
    "fr": "Mes compétences"
  },
  "My Journey": {
    "en": "My Journey",
    "fr": "Mon parcours"
  },
  "Let's Work Together": {
    "en": "Let's Work Together",
    "fr": "Travaillons ensemble"
  },
  "Whether you have a specific project in mind or just want to explore possibilities, I'd love to hear from you.": {
    "en": "Whether you have a specific project in mind or just want to explore possibilities, I'd love to hear from you.",
    "fr": "Que vous ayez un projet précis ou souhaitiez simplement explorer les possibilités, je serai ravi d’en discuter avec vous."
  },
  "Sending message...": {
    "en": "Sending message...",
    "fr": "Envoi du message…"
  },
  "Message sent successfully!": {
    "en": "Message sent successfully!",
    "fr": "Message envoyé avec succès !"
  },
  "Failed to send message. Please try again.": {
    "en": "Failed to send message. Please try again.",
    "fr": "Impossible d’envoyer le message. Veuillez réessayer."
  },
  "Location": {
    "en": "Location",
    "fr": "Localisation"
  },
  "What types of projects do you work on?": {
    "en": "What types of projects do you work on?",
    "fr": "Sur quels types de projets travaillez-vous ?"
  },
  "I specialize in web development, AI integration, and automation projects.": {
    "en": "I specialize in web development, AI integration, and automation projects.",
    "fr": "Je suis spécialisé dans le développement web, l’intégration de l’IA et l’automatisation."
  },
  "What is your typical process?": {
    "en": "What is your typical process?",
    "fr": "Comment se déroule un projet ?"
  },
  "Initial consultation, requirements gathering, proposal, development, testing, and deployment.": {
    "en": "Initial consultation, requirements gathering, proposal, development, testing, and deployment.",
    "fr": "Premier échange, analyse des besoins, proposition, développement, tests et mise en production."
  },
  "How do you handle pricing?": {
    "en": "How do you handle pricing?",
    "fr": "Comment définissez-vous vos tarifs ?"
  },
  "I offer both hourly rates and fixed-price quotes depending on the project.": {
    "en": "I offer both hourly rates and fixed-price quotes depending on the project.",
    "fr": "Je propose une facturation au temps passé ou au forfait, selon le projet."
  },
  "Do you provide ongoing maintenance?": {
    "en": "Do you provide ongoing maintenance?",
    "fr": "Assurez-vous la maintenance ?"
  },
  "Yes, through retainer agreements or as-needed arrangements.": {
    "en": "Yes, through retainer agreements or as-needed arrangements.",
    "fr": "Oui, dans le cadre d’un contrat de maintenance ou d’interventions ponctuelles."
  },
  "Have a project in mind or want to discuss a potential collaboration?": {
    "en": "Have a project in mind or want to discuss a potential collaboration?",
    "fr": "Un projet en tête ou une envie de collaboration ?"
  },
  "I'd love to hear from you!": {
    "en": "I'd love to hear from you!",
    "fr": "Je serai ravi d’en discuter avec vous !"
  },
  "Send a Message": {
    "en": "Send a Message",
    "fr": "Envoyer un message"
  },
  "Your Name": {
    "en": "Your Name",
    "fr": "Votre nom"
  },
  "John Doe": {
    "en": "John Doe",
    "fr": "Jean Dupont"
  },
  "Your Email": {
    "en": "Your Email",
    "fr": "Votre email"
  },
  "Subject": {
    "en": "Subject",
    "fr": "Objet"
  },
  "How can I help you?": {
    "en": "How can I help you?",
    "fr": "Comment puis-je vous aider ?"
  },
  "Your Message": {
    "en": "Your Message",
    "fr": "Votre message"
  },
  "Tell me about your project...": {
    "en": "Tell me about your project...",
    "fr": "Parlez-moi de votre projet…"
  },
  "Sending...": {
    "en": "Sending...",
    "fr": "Envoi…"
  },
  "Send Message": {
    "en": "Send Message",
    "fr": "Envoyer le message"
  },
  "Contact Information": {
    "en": "Contact Information",
    "fr": "Coordonnées"
  },
  "Connect on Social Media": {
    "en": "Connect on Social Media",
    "fr": "Retrouvez-moi sur les réseaux sociaux"
  },
  "Availability": {
    "en": "Availability",
    "fr": "Disponibilité"
  },
  "I'm currently": {
    "en": "I'm currently",
    "fr": "Je suis actuellement"
  },
  "available": {
    "en": "available",
    "fr": "disponible"
  },
  "for freelance work and consulting. Typical response time is within 24-48 hours.": {
    "en": "for freelance work and consulting. Typical response time is within 24-48 hours.",
    "fr": "pour des missions indépendantes et du conseil. Je réponds généralement sous 24 à 48 heures."
  },
  "Frequently Asked Questions": {
    "en": "Frequently Asked Questions",
    "fr": "Questions fréquentes"
  },
  "Please enter both email and password.": {
    "en": "Please enter both email and password.",
    "fr": "Veuillez saisir votre email et votre mot de passe."
  },
  "Admin Login": {
    "en": "Admin Login",
    "fr": "Connexion administrateur"
  },
  "Email address": {
    "en": "Email address",
    "fr": "Adresse email"
  },
  "Password": {
    "en": "Password",
    "fr": "Mot de passe"
  },
  "Logging in...": {
    "en": "Logging in...",
    "fr": "Connexion…"
  },
  "Sign in": {
    "en": "Sign in",
    "fr": "Se connecter"
  },
  "Failed to load blog post": {
    "en": "Failed to load blog post",
    "fr": "Impossible de charger l’article"
  },
  "Unable to load blog post": {
    "en": "Unable to load blog post",
    "fr": "Impossible de charger l’article"
  },
  "Blog post not found": {
    "en": "Blog post not found",
    "fr": "Article introuvable"
  },
  "Return to Blog": {
    "en": "Return to Blog",
    "fr": "Retour au blog"
  },
  "Back to all articles": {
    "en": "Back to all articles",
    "fr": "Retour aux articles"
  },
  "About the Author": {
    "en": "About the Author",
    "fr": "À propos de l’auteur"
  },
  "Developer & IT Professional": {
    "en": "Developer & IT Professional",
    "fr": "Développeur et professionnel de l’informatique"
  },
  "A passionate developer with over a decade of experience in creating innovative solutions.": {
    "en": "A passionate developer with over a decade of experience in creating innovative solutions.",
    "fr": "Un développeur passionné avec plus de dix ans d’expérience dans la création de solutions innovantes."
  },
  "Related Articles": {
    "en": "Related Articles",
    "fr": "Articles similaires"
  },
  "Fév 2020 - Présent": {
    "en": "Feb 2020 - Present",
    "fr": "Fév 2020 - Présent"
  },
  "Oct 2020 - Présent": {
    "en": "Oct 2020 - Present",
    "fr": "Oct 2020 - Présent"
  },
  "Sep 2014 - Août 2015": {
    "en": "Sep 2014 - Aug 2015",
    "fr": "Sep 2014 - Août 2015"
  },
  "Développement de solutions web et mobiles, spécialisation en IA et automatisation des processus.": {
    "en": "Development of web and mobile solutions, specializing in AI and process automation.",
    "fr": "Développement de solutions web et mobiles, spécialisation en IA et automatisation des processus."
  },
  "Direction du département informatique, gestion d'équipe et pilotage de projets techniques.": {
    "en": "Leading the IT department, managing the team and overseeing technical projects.",
    "fr": "Direction du département informatique, gestion d'équipe et pilotage de projets techniques."
  },
  "Développement d'applications internes et modernisation des outils métier.": {
    "en": "Developing internal applications and modernizing business tools.",
    "fr": "Développement d'applications internes et modernisation des outils métier."
  },
  "Ingénieur de recherche en développement logiciel et solutions innovantes.": {
    "en": "Research engineer in software development and innovative solutions.",
    "fr": "Ingénieur de recherche en développement logiciel et solutions innovantes."
  },
  "Conception et développement d'applications web et mobiles pour le secteur médical.": {
    "en": "Designing and developing web and mobile applications for the medical sector.",
    "fr": "Conception et développement d'applications web et mobiles pour le secteur médical."
  },
  "Développement ERP en .Net (C#) et analyse des besoins métier.": {
    "en": "ERP development in .Net (C#) and business requirements analysis.",
    "fr": "Développement ERP en .Net (C#) et analyse des besoins métier."
  },
  "Prix et financement": {
    "en": "Price and financing",
    "fr": "Prix et financement"
  },
  "Dépréciation": {
    "en": "Depreciation",
    "fr": "Dépréciation"
  },
  "Assurance": {
    "en": "Insurance",
    "fr": "Assurance"
  },
  "Entretien et pneus": {
    "en": "Maintenance and tyres",
    "fr": "Entretien et pneus"
  },
  "Consommation": {
    "en": "Energy consumption",
    "fr": "Consommation"
  },
  "Taxes et imprévus": {
    "en": "Taxes and unexpected costs",
    "fr": "Taxes et imprévus"
  },
  "Cadrer": {
    "en": "Define",
    "fr": "Cadrer"
  },
  "Budget, trajets, kilométrage, horizon de détention, contraintes familiales et compromis acceptables.": {
    "en": "Budget, journeys, mileage, ownership period, family needs and acceptable compromises.",
    "fr": "Budget, trajets, kilométrage, horizon de détention, contraintes familiales et compromis acceptables."
  },
  "Comparer": {
    "en": "Compare",
    "fr": "Comparer"
  },
  "Générations, motorisations, coût global prévisible, retours d’usage et réalité du marché.": {
    "en": "Generations, powertrains, expected total cost, owner feedback and market conditions.",
    "fr": "Générations, motorisations, coût global prévisible, retours d’usage et réalité du marché."
  },
  "Classer": {
    "en": "Rank",
    "fr": "Classer"
  },
  "Trois à cinq options hiérarchisées, avec les raisons du choix, les concessions et le mode d’acquisition pertinent.": {
    "en": "Three to five ranked options, with reasons for each choice, trade-offs and a suitable acquisition method.",
    "fr": "Trois à cinq options hiérarchisées, avec les raisons du choix, les concessions et le mode d’acquisition pertinent."
  },
  "Décider": {
    "en": "Decide",
    "fr": "Décider"
  },
  "Un dossier lisible, des annonces repères, les questions à poser et un débrief de 30 minutes.": {
    "en": "A clear report, example listings, questions to ask and a 30-minute debrief.",
    "fr": "Un dossier lisible, des annonces repères, les questions à poser et un débrief de 30 minutes."
  },
  "Pourquoi payer alors que ChatGPT et Reddit sont gratuits ?": {
    "en": "Why pay when ChatGPT and Reddit are free?",
    "fr": "Pourquoi payer alors que ChatGPT et Reddit sont gratuits ?"
  },
  "Parce que l’information gratuite reste à cadrer, trier, vérifier et pondérer selon votre situation. La Bonne Voiture ne vend pas un accès à des données secrètes : vous déléguez une recherche structurée et obtenez une décision argumentée.": {
    "en": "Because free information still needs to be scoped, sorted, checked and weighed against your situation. La Bonne Voiture does not sell access to secret data: you delegate structured research and receive a reasoned recommendation.",
    "fr": "Parce que l’information gratuite reste à cadrer, trier, vérifier et pondérer selon votre situation. La Bonne Voiture ne vend pas un accès à des données secrètes : vous déléguez une recherche structurée et obtenez une décision argumentée."
  },
  "Pouvez-vous aussi m’aider à choisir entre achat, crédit, LOA ou LLD ?": {
    "en": "Can you also help me choose between buying, a loan or leasing?",
    "fr": "Pouvez-vous aussi m’aider à choisir entre achat, crédit, LOA ou LLD ?"
  },
  "Oui. Le dossier peut comparer les avantages, les contraintes et le coût global des différents modes d’acquisition selon votre kilométrage, votre apport et la durée pendant laquelle vous souhaitez garder la voiture. Aucun financement n’est commercialisé.": {
    "en": "Yes. The report can compare the benefits, constraints and total cost of different acquisition methods based on your mileage, deposit and intended ownership period. No financing products are sold.",
    "fr": "Oui. Le dossier peut comparer les avantages, les contraintes et le coût global des différents modes d’acquisition selon votre kilométrage, votre apport et la durée pendant laquelle vous souhaitez garder la voiture. Aucun financement n’est commercialisé."
  },
  "Est-ce une inspection mécanique ?": {
    "en": "Is this a mechanical inspection?",
    "fr": "Est-ce une inspection mécanique ?"
  },
  "Non. La mission intervient en amont pour choisir les bons modèles et identifier les contrôles importants. Elle ne remplace ni un essai, ni l’historique du véhicule, ni une inspection physique par un professionnel.": {
    "en": "No. This service helps you choose suitable models and identify important checks before buying. It does not replace a test drive, vehicle history or a physical inspection by a professional.",
    "fr": "Non. La mission intervient en amont pour choisir les bons modèles et identifier les contrôles importants. Elle ne remplace ni un essai, ni l’historique du véhicule, ni une inspection physique par un professionnel."
  },
  "Y a-t-il une commission sur la voiture achetée ?": {
    "en": "Is there a commission on the car purchased?",
    "fr": "Y a-t-il une commission sur la voiture achetée ?"
  },
  "Non. Le prix est fixe et payé uniquement par vous. Aucun vendeur, garage ou site d’annonces ne rémunère la recommandation.": {
    "en": "No. The fee is fixed and paid only by you. No seller, garage or listings website pays for the recommendation.",
    "fr": "Non. Le prix est fixe et payé uniquement par vous. Aucun vendeur, garage ou site d’annonces ne rémunère la recommandation."
  },
  "Quels projets correspondent à l’offre pilote ?": {
    "en": "Which projects suit the pilot offer?",
    "fr": "Quels projets correspondent à l’offre pilote ?"
  },
  "Principalement les véhicules d’occasion courants entre 15 000 € et 35 000 €. Les véhicules de collection, imports complexes et modèles très haut de gamme demandent un cadrage séparé.": {
    "en": "Mainly mainstream used cars priced between €15,000 and €35,000. Classic cars, complex imports and high-end models require a separate scope.",
    "fr": "Principalement les véhicules d’occasion courants entre 15 000 € et 35 000 €. Les véhicules de collection, imports complexes et modèles très haut de gamme demandent un cadrage séparé."
  },
  "Envoi de votre demande…": {
    "en": "Sending your request…",
    "fr": "Envoi de votre demande…"
  },
  "Demande envoyée. Je reviens vers vous rapidement.": {
    "en": "Request sent. I’ll get back to you shortly.",
    "fr": "Demande envoyée. Je reviens vers vous rapidement."
  },
  "Impossible d’envoyer la demande pour le moment.": {
    "en": "Unable to send your request right now.",
    "fr": "Impossible d’envoyer la demande pour le moment."
  },
  "La Bonne Voiture, accueil": {
    "en": "La Bonne Voiture, home",
    "fr": "La Bonne Voiture, accueil"
  },
  "Navigation principale": {
    "en": "Main navigation",
    "fr": "Navigation principale"
  },
  "Coût réel": {
    "en": "Real cost",
    "fr": "Coût réel"
  },
  "Méthode": {
    "en": "Method",
    "fr": "Méthode"
  },
  "Décrire mon besoin": {
    "en": "Describe my needs",
    "fr": "Décrire mon besoin"
  },
  "Conseil automobile indépendant": {
    "en": "Independent car advice",
    "fr": "Conseil automobile indépendant"
  },
  "La voiture qui colle à votre vie.": {
    "en": "The car that fits your life.",
    "fr": "La voiture qui colle à votre vie."
  },
  "Et à votre budget réel.": {
    "en": "And your actual budget.",
    "fr": "Et à votre budget réel."
  },
  "Une shortlist personnalisée et un avis sur le mode d’acquisition, construits à partir de vos usages, de votre budget et des compromis que vous êtes réellement prêt à faire.": {
    "en": "A personalized shortlist and advice on how to acquire your car, based on your needs, budget and the compromises you are actually willing to make.",
    "fr": "Une shortlist personnalisée et un avis sur le mode d’acquisition, construits à partir de vos usages, de votre budget et des compromis que vous êtes réellement prêt à faire."
  },
  "Lancer ma recherche": {
    "en": "Start my search",
    "fr": "Lancer ma recherche"
  },
  "Voir ce que je compare": {
    "en": "See what I compare",
    "fr": "Voir ce que je compare"
  },
  "Lecture": {
    "en": "Focus",
    "fr": "Lecture"
  },
  "Coût global": {
    "en": "Total cost",
    "fr": "Coût global"
  },
  "Offre pilote": {
    "en": "Pilot offer",
    "fr": "Offre pilote"
  },
  "Une voiture familiale argentée sur une zone d’essai traversée par une ligne bleue": {
    "en": "A silver family car on a test area crossed by a blue line",
    "fr": "Une voiture familiale argentée sur une zone d’essai traversée par une ligne bleue"
  },
  "Objectif": {
    "en": "Goal",
    "fr": "Objectif"
  },
  "Choisir avant de chercher": {
    "en": "Choose before searching",
    "fr": "Choisir avant de chercher"
  },
  "Manifeste": {
    "en": "Manifesto",
    "fr": "Manifeste"
  },
  "Votre usage, pas un stock.": {
    "en": "Your needs, not an inventory.",
    "fr": "Votre usage, pas un stock."
  },
  "Votre coût, pas une mensualité.": {
    "en": "Your total cost, not a monthly payment.",
    "fr": "Votre coût, pas une mensualité."
  },
  "Le vrai budget automobile": {
    "en": "The real car budget",
    "fr": "Le vrai budget automobile"
  },
  "Le prix affiché n’est que le début du calcul.": {
    "en": "The sticker price is only the start.",
    "fr": "Le prix affiché n’est que le début du calcul."
  },
  "Les transports absorbent": {
    "en": "Transport accounts for",
    "fr": "Les transports absorbent"
  },
  "de la dépense de consommation des ménages en 2024. Une voiture engage donc l’un des grands budgets du foyer, souvent pendant plusieurs années.": {
    "en": "of household consumption expenditure in 2024. A car is therefore one of a household’s major expenses, often for several years.",
    "fr": "de la dépense de consommation des ménages en 2024. Une voiture engage donc l’un des grands budgets du foyer, souvent pendant plusieurs années."
  },
  "Dans le même temps, la LOA représentait près de": {
    "en": "Meanwhile, leasing with an option to buy accounted for nearly",
    "fr": "Dans le même temps, la LOA représentait près de"
  },
  "des opérations de financement spécialisé de voitures neuves recensées en 2024, hors prêts personnels. Sa popularité ne signifie pas qu’elle corresponde à tous les usages.": {
    "en": "of recorded specialist new-car financing transactions in 2024, excluding personal loans. Its popularity does not mean it suits every use case.",
    "fr": "des opérations de financement spécialisé de voitures neuves recensées en 2024, hors prêts personnels. Sa popularité ne signifie pas qu’elle corresponde à tous les usages."
  },
  "Pour comparer deux voitures correctement, je regarde l’ensemble de ce qui sera réellement payé ou perdu pendant la détention :": {
    "en": "To compare two cars properly, I consider everything actually paid or lost during ownership:",
    "fr": "Pour comparer deux voitures correctement, je regarde l’ensemble de ce qui sera réellement payé ou perdu pendant la détention :"
  },
  "Sources :": {
    "en": "Sources:",
    "fr": "Sources :"
  },
  "Insee, dépenses des ménages 2024": {
    "en": "Insee, household expenditure 2024",
    "fr": "Insee, dépenses des ménages 2024"
  },
  "ASF, financements 2024": {
    "en": "ASF, financing 2024",
    "fr": "ASF, financements 2024"
  },
  "Institut national de la consommation": {
    "en": "French National Consumer Institute",
    "fr": "Institut national de la consommation"
  },
  "Pourquoi déléguer": {
    "en": "Why delegate",
    "fr": "Pourquoi déléguer"
  },
  "Plus d’information ne crée pas toujours une meilleure décision.": {
    "en": "More information does not always lead to a better decision.",
    "fr": "Plus d’information ne crée pas toujours une meilleure décision."
  },
  "Motorisations, niveaux de finition, packs d’options, millésimes, garanties, fiscalité, restrictions de circulation et financement : l’offre est pléthorique et les comparaisons sont rarement faites à périmètre égal.": {
    "en": "Powertrains, trim levels, option packs, model years, warranties, taxes, driving restrictions and financing: the choice is vast and comparisons rarely use the same criteria.",
    "fr": "Motorisations, niveaux de finition, packs d’options, millésimes, garanties, fiscalité, restrictions de circulation et financement : l’offre est pléthorique et les comparaisons sont rarement faites à périmètre égal."
  },
  "Comparateurs, vidéos, forums et IA donnent des pistes. Mais lorsque tout semble possible, les critères importants se mélangent : usage réel, fiabilité, agrément, budget global et disponibilité.": {
    "en": "Comparison sites, videos, forums and AI provide ideas. But when everything seems possible, the important criteria get blurred: actual usage, reliability, driving enjoyment, total budget and availability.",
    "fr": "Comparateurs, vidéos, forums et IA donnent des pistes. Mais lorsque tout semble possible, les critères importants se mélangent : usage réel, fiabilité, agrément, budget global et disponibilité."
  },
  "Les outils gratuits donnent des pistes.": {
    "en": "Free tools provide ideas.",
    "fr": "Les outils gratuits donnent des pistes."
  },
  "La Bonne Voiture prend la responsabilité de la synthèse.": {
    "en": "La Bonne Voiture takes responsibility for bringing it all together.",
    "fr": "La Bonne Voiture prend la responsabilité de la synthèse."
  },
  "Aucune marque. Aucun vendeur. Aucune commission.": {
    "en": "No brand. No seller. No commission.",
    "fr": "Aucune marque. Aucun vendeur. Aucune commission."
  },
  "« Je ne vous oriente pas vers ce que j’ai à vendre. Je n’ai aucune voiture à placer. »": {
    "en": "“I don’t steer you towards something I’m selling. I have no cars to sell.”",
    "fr": "« Je ne vous oriente pas vers ce que j’ai à vendre. Je n’ai aucune voiture à placer. »"
  },
  "Votre conseiller": {
    "en": "Your adviser",
    "fr": "Votre conseiller"
  },
  "Passionné d’automobile. Indépendant par construction.": {
    "en": "Passionate about cars. Independent by design.",
    "fr": "Passionné d’automobile. Indépendant par construction."
  },
  "Nous définissons vos critères lors d’un entretien. J’affine ensuite la recherche à partir de mes connaissances et de vérifications ciblées, puis je hiérarchise les véhicules qui répondent vraiment à votre situation.": {
    "en": "We define your criteria in a consultation. I then refine the research using my knowledge and targeted checks, before ranking the vehicles that truly suit your situation.",
    "fr": "Nous définissons vos critères lors d’un entretien. J’affine ensuite la recherche à partir de mes connaissances et de vérifications ciblées, puis je hiérarchise les véhicules qui répondent vraiment à votre situation."
  },
  "Entretien": {
    "en": "Consultation",
    "fr": "Entretien"
  },
  "Vos usages, contraintes, envies et compromis deviennent un cahier des charges clair.": {
    "en": "Your usage, constraints, preferences and compromises become a clear brief.",
    "fr": "Vos usages, contraintes, envies et compromis deviennent un cahier des charges clair."
  },
  "Recherche": {
    "en": "Research",
    "fr": "Recherche"
  },
  "Je confronte les modèles, versions et motorisations à la réalité de votre projet.": {
    "en": "I assess models, versions and powertrains against the reality of your project.",
    "fr": "Je confronte les modèles, versions et motorisations à la réalité de votre projet."
  },
  "J’éclaire achat comptant, crédit, LOA ou LLD sans commercialiser de financement.": {
    "en": "I explain cash purchases, loans and leasing options without selling financing.",
    "fr": "J’éclaire achat comptant, crédit, LOA ou LLD sans commercialiser de financement."
  },
  "La méthode": {
    "en": "The method",
    "fr": "La méthode"
  },
  "Quatre étapes. Aucun véhicule à placer.": {
    "en": "Four steps. No cars to sell.",
    "fr": "Quatre étapes. Aucun véhicule à placer."
  },
  "La recommandation part de votre quotidien et reste indépendante de toute plateforme, vendeur ou commission.": {
    "en": "The recommendation starts with your daily life and remains independent of any platform, seller or commission.",
    "fr": "La recommandation part de votre quotidien et reste indépendante de toute plateforme, vendeur ou commission."
  },
  "Le dossier": {
    "en": "The report",
    "fr": "Le dossier"
  },
  "Un dossier fait pour trancher, pas pour impressionner.": {
    "en": "A report designed to help you decide, not to impress.",
    "fr": "Un dossier fait pour trancher, pas pour impressionner."
  },
  "Chaque option est classée, expliquée et replacée dans son contexte. Le dossier garde une trace des arbitrages lorsque les annonces et les avis commencent à brouiller la décision.": {
    "en": "Each option is ranked, explained and put into context. The report records the trade-offs when listings and opinions start to cloud the decision.",
    "fr": "Chaque option est classée, expliquée et replacée dans son contexte. Le dossier garde une trace des arbitrages lorsque les annonces et les avis commencent à brouiller la décision."
  },
  "Combinaison modèle, génération et motorisation": {
    "en": "Model, generation and powertrain combination",
    "fr": "Combinaison modèle, génération et motorisation"
  },
  "Comparaison du coût global sur votre durée de détention": {
    "en": "Total cost comparison over your ownership period",
    "fr": "Comparaison du coût global sur votre durée de détention"
  },
  "Avis sur achat comptant, crédit, LOA ou LLD": {
    "en": "Advice on cash purchases, loans and leasing",
    "fr": "Avis sur achat comptant, crédit, LOA ou LLD"
  },
  "Forces, concessions et cas d’usage": {
    "en": "Strengths, compromises and use cases",
    "fr": "Forces, concessions et cas d’usage"
  },
  "Points de vigilance à contrôler": {
    "en": "Key issues to check",
    "fr": "Points de vigilance à contrôler"
  },
  "Annonces repères et questions à poser": {
    "en": "Example listings and questions to ask",
    "fr": "Annonces repères et questions à poser"
  },
  "Aperçu générique du dossier": {
    "en": "Sample report preview",
    "fr": "Aperçu générique du dossier"
  },
  "LA BONNE VOITURE / DOSSIER 001": {
    "en": "LA BONNE VOITURE / REPORT 001",
    "fr": "LA BONNE VOITURE / DOSSIER 001"
  },
  "Usage mixte — famille": {
    "en": "Mixed use — family",
    "fr": "Usage mixte — famille"
  },
  "Meilleur équilibre": {
    "en": "Best balance",
    "fr": "Meilleur équilibre"
  },
  "Option recommandée": {
    "en": "Recommended option",
    "fr": "Option recommandée"
  },
  "Choix rationnel": {
    "en": "Practical choice",
    "fr": "Choix rationnel"
  },
  "Budget préservé": {
    "en": "Budget protected",
    "fr": "Budget préservé"
  },
  "Alternative plaisir": {
    "en": "Fun alternative",
    "fr": "Alternative plaisir"
  },
  "Compromis assumé": {
    "en": "Accepted trade-off",
    "fr": "Compromis assumé"
  },
  "Exemple de structure — données et modèles fictifs": {
    "en": "Sample structure — fictional data and models",
    "fr": "Exemple de structure — données et modèles fictifs"
  },
  "€ TTC": {
    "en": "€ incl. VAT",
    "fr": "€ TTC"
  },
  "Prix fixe, quel que soit le prix du véhicule. La mission rémunère la recherche et la décision, jamais la transaction.": {
    "en": "A fixed fee, regardless of the vehicle’s price. You pay for research and decision support, never the transaction.",
    "fr": "Prix fixe, quel que soit le prix du véhicule. La mission rémunère la recherche et la décision, jamais la transaction."
  },
  "Inclus dans la mission": {
    "en": "Included in the service",
    "fr": "Inclus dans la mission"
  },
  "Échange de cadrage": {
    "en": "Initial consultation",
    "fr": "Échange de cadrage"
  },
  "Shortlist de 3 à 5 options": {
    "en": "Shortlist of 3 to 5 options",
    "fr": "Shortlist de 3 à 5 options"
  },
  "Dossier argumenté": {
    "en": "Reasoned report",
    "fr": "Dossier argumenté"
  },
  "Avis sur le mode d’acquisition": {
    "en": "Advice on acquisition method",
    "fr": "Avis sur le mode d’acquisition"
  },
  "Débrief de 30 minutes": {
    "en": "30-minute debrief",
    "fr": "Débrief de 30 minutes"
  },
  "Une révision incluse": {
    "en": "One revision included",
    "fr": "Une révision incluse"
  },
  "Vérifier si l’offre me correspond": {
    "en": "Check if this offer suits me",
    "fr": "Vérifier si l’offre me correspond"
  },
  "Questions fréquentes": {
    "en": "Frequently asked questions",
    "fr": "Questions fréquentes"
  },
  "Ce que La Bonne Voiture fait. Et ce qu’elle ne prétend pas faire.": {
    "en": "What La Bonne Voiture does. And what it does not claim to do.",
    "fr": "Ce que La Bonne Voiture fait. Et ce qu’elle ne prétend pas faire."
  },
  "Premier échange": {
    "en": "First contact",
    "fr": "Premier échange"
  },
  "Décrivez la voiture qu’il vous faut. Même si vous ne la connaissez pas encore.": {
    "en": "Describe the car you need. Even if you don’t know what it is yet.",
    "fr": "Décrivez la voiture qu’il vous faut. Même si vous ne la connaissez pas encore."
  },
  "Quelques lignes suffisent. Vous recevrez d’abord un retour honnête sur l’adéquation de l’offre à votre projet.": {
    "en": "A few lines are enough. You’ll first receive honest feedback on whether the offer suits your project.",
    "fr": "Quelques lignes suffisent. Vous recevrez d’abord un retour honnête sur l’adéquation de l’offre à votre projet."
  },
  "Votre nom": {
    "en": "Your name",
    "fr": "Votre nom"
  },
  "Votre email": {
    "en": "Your email",
    "fr": "Votre email"
  },
  "Budget approximatif": {
    "en": "Approximate budget",
    "fr": "Budget approximatif"
  },
  "Ex. 25 000 €": {
    "en": "E.g. €25,000",
    "fr": "Ex. 25 000 €"
  },
  "Mode d’acquisition envisagé": {
    "en": "Preferred acquisition method",
    "fr": "Mode d’acquisition envisagé"
  },
  "Je ne sais pas encore": {
    "en": "I’m not sure yet",
    "fr": "Je ne sais pas encore"
  },
  "Achat comptant": {
    "en": "Cash purchase",
    "fr": "Achat comptant"
  },
  "Crédit": {
    "en": "Loan",
    "fr": "Crédit"
  },
  "LOA": {
    "en": "Lease with purchase option (LOA)",
    "fr": "LOA"
  },
  "LLD": {
    "en": "Long-term lease (LLD)",
    "fr": "LLD"
  },
  "Usage, contraintes, hésitations": {
    "en": "Usage, constraints and questions",
    "fr": "Usage, contraintes, hésitations"
  },
  "Ex. 20 000 km/an, deux enfants, trajets mixtes, hésitation hybride/essence…": {
    "en": "E.g. 20,000 km/year, two children, mixed journeys, deciding between hybrid and petrol…",
    "fr": "Ex. 20 000 km/an, deux enfants, trajets mixtes, hésitation hybride/essence…"
  },
  "Envoi…": {
    "en": "Sending…",
    "fr": "Envoi…"
  },
  "Envoyer ma demande": {
    "en": "Send my request",
    "fr": "Envoyer ma demande"
  },
  "Conseil automobile indépendant · Projet pilote": {
    "en": "Independent car advice · Pilot project",
    "fr": "Conseil automobile indépendant · Projet pilote"
  },
  "Retour en haut ↑": {
    "en": "Back to top ↑",
    "fr": "Retour en haut ↑"
  }
} as const;
